import cn from 'clsx'
import React, { FC, ReactNode } from 'react'
import { a, useSpring } from '@react-spring/web'
import useMeasure from 'react-use-measure'
import { ChevronRight } from '@components/icons'

export interface CollapseProps {
  title: string
  children: ReactNode
  onClick?: () => void
  isActive?: boolean
  noBorder?: boolean
  withBottomMargin?: boolean
}

const Collapse: FC<CollapseProps> = ({
  title,
  children,
  noBorder = false,
  withBottomMargin = false,
  onClick,
  isActive = false,
}) => {
  const [ref, { height: viewHeight }] = useMeasure()

  const animProps = useSpring({
    height: isActive ? viewHeight : 0,
    config: { tension: 250, friction: 32, clamp: true, duration: 150 },
    opacity: isActive ? 1 : 0,
  })

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className={cn('border-deepPurple py-7 flex flex-col outline-none', {
        'border-b': !noBorder,
        'pb-8': withBottomMargin,
      })}
      role="button"
      tabIndex={0}
      aria-expanded={isActive}
      onClick={onClick}
    >
      <div
        className={
          'flex flex-row items-center justify-between text-base font-medium'
        }
      >
        <span className={'font-bold text-xl mr-4'}>{title}</span>
        <ChevronRight
          className={cn('mr-3 text-accent-6', { 'rotate-90': isActive })}
        />
      </div>
      <a.div style={{ overflow: 'hidden', ...animProps }}>
        <div ref={ref} className={'pt-3 overflow-hidden max-w-xl mr-auto'}>
          {children}
        </div>
      </a.div>
    </div>
  )
}

export default React.memo(Collapse)
